import { createContext } from 'react';

import type { CalendarSettingsState } from '@app/providers/CalendarProvider/CalendarSettingsContext.types';

export const CalendarSettingsContext = createContext<CalendarSettingsState>({
  initialTimes: [],
  timeFormat: null,
  setTimeFormat: () => {},
  branchTimezone: null,
  setBranchTimezone: () => {},
  branchEmployees: [],
  setBranchEmployees: () => {},
  lastStoredBranchEmployees: [],
  setLastStoredBranchEmployees: () => {},
  dateString: '',
  isLoading: false,
  setIsLoading: () => {},
  isLoadingPage: false,
  verticalScrollContainerRef: { current: null },
});
